<template>
    <transition name="el-fade-in-linear">
        <el-dialog
            :title="logConfig.title"
            :width="logConfig.width"
            :visible.sync="showDialog"
            :close-on-click-modal="logConfig.closeOnClickModal"
            :center="logConfig.center"
            @close="close"
        >
            <el-table :data="tableData" :height="logConfig.height" border v-loading="logListLoading" style="width: 100%" empty-text="暂无数据">
                <el-table-column v-for="(item,index) in logConfig.column" :key="index" :prop="item.prop" :align="item.align|| 'center'" :class-name="item.className" :label="item.label" :sortable="item.sortable" :show-overflow-tooltip="item.showOverflowTooltip" :width="item.width" :min-width="item.minWidth|| '110'" :fixed="item.fixed">
                    <template slot-scope="scope">

                        <!-- 需要格式化内容 -->
                        <template v-if="item.formatter">
                            <template v-if="item.type === 'tag'" >
                                <template v-if="Array.isArray(scope.row[item.prop])">
                                    <el-tag v-for="(tagItem,tagIndex) in scope.row[item.prop]" :key="tagIndex">{{tagItem}}</el-tag>
                                </template>
                                <template v-else>
                                    <!-- 带不同颜色的tag 格式：值-colorType -->
                                    <el-tag  v-html="item.formatter(scope.row[item.prop], scope.row, item).split('-')[0]" :type="item.formatter(scope.row[item.prop], scope.row, item).split('-')[1]"></el-tag>
                                </template>
                            </template>

                            <span v-else v-html="item.formatter(scope.row[item.prop], scope.row, item)"></span>
                        </template>

                        <!-- 不需要格式化内容 -->
                        <template v-else>
                            <span>{{scope.row[item.prop]}}</span>
                        </template>
                    </template>
                </el-table-column>
            </el-table>

            <div class="log-pagination" v-if="logConfig.showPage">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-size="logPageConfig.pageSize"
                    :page-sizes="logPageConfig.pageSizes"
                    :current-page="logPageConfig.pageIndex"
                    :layout="logPageConfig.layout || 'total, sizes, prev, pager, next'"
                    :total="logPageConfig.total">
                    
                </el-pagination>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button @click.native="close">关闭</el-button>
            </div>
        </el-dialog>
    </transition>
</template>
<script>
import util from "../../../../util/date";
import { axios, BaseApiUrl } from '@/api/axios_config';
export default {
  name: "logDialog",
  data() {
    return {
        showDialog: this.showLog,
        tableData:[],
        logListLoading: false
    };
  },
  props: {
    logConfig: {
      type: Object,
      default:function() {
          return {
            title: '日志',
            width:'50%',
            showPage: true,
           
            column: [
                {
                    prop: 'createBy',
                    label: '操作人',
                    sortable: true,
                    align: 'center'
                },
                {
                    prop: 'ip',
                    label: '操作人IP地址',
                    sortable: true,
                    align: 'center'
                },
                {
                    prop: 'createTime',
                    label: '操作时间',
                    sortable: true,
                    align: 'center',
                    formatter:function(val){
                        return !val || val == "" ? "" : util.formatDate.format(new Date(val), "yyyy-MM-dd hh:mm:ss");
                    }
                },
                {
                    prop: 'description',
                    label: '操作内容',
                    sortable: true,
                    align: 'center'
                },
            ]
        }
      }
    },
    logPageConfig: {
      type: Object,
      default:function() {
          return {
            total: 0,
            pageIndex: 1,
            pageSize: 10,
            pageSizes: [10,20,50,100]
        }
      }
    },
    showLog: {
      type: Boolean
    },
    requestData: {
      type: Object
    },
    requestApi: {
      type: String
    },
    requestMethod: {
      type: String
    }
  },

  created(){
      this.initTable()
  },

  mounted() {
  },

  methods: {
      initTable(){
         const data = {
             ...this.requestData,
            page: this.logPageConfig.pageIndex,
            pageSize: this.logPageConfig.pageSize,
         }
         this.tableData = []
         this.logListLoading = true
        this.request(data).then(res=>{
            this.logListLoading = false
            if(res.status === 200 && res.success){
                const {total,pageData,pageIndex,pageSize,pageCount} = res.response
                this.tableData = pageData
                this.$set(this.logPageConfig,'pageIndex',pageIndex)
                this.$set(this.logPageConfig,'total',total)
                this.$set(this.logPageConfig,'pageSize',pageSize)
            }
        })
      },
      request(params){
          const methods = this.requestMethod.toLowerCase()
          return axios[methods](`${BaseApiUrl}${this.requestApi}`, methods === 'get'? { params: params }:params).then(res => res.data)
      },
      close(){
            this.$set(this.logPageConfig,'pageIndex',1)
          this.$emit('showDialog')
      },
      handleSizeChange(val){
        //   this.$emit('handleLogSizeChange',val)
        this.$set(this.logPageConfig,'pageSize',val)
        this.initTable()
      },
      handleCurrentChange(val){
        //   this.$emit('handleLogCurrentChange',val)
        this.$set(this.logPageConfig,'pageIndex',val)
        this.initTable()
      }
  }
};
</script>

<style scoped>
    .log-pagination{
        float: right;
        padding: 3px 0px;
    }
</style>